import { render, staticRenderFns } from "./CommonToolCard.vue?vue&type=template&id=c4fad98a&scoped=true"
import script from "./CommonToolCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonToolCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommonToolCard.vue?vue&type=style&index=0&id=c4fad98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fad98a",
  null
  
)

export default component.exports